/**
 * @desc 更新质检附件
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.StorageMasterUrlUpdateDto, options?: any) {
  return updateResponse(
    http(URL + `/storageDamageMaster/updateInspectionFileUrl`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
